import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestTypes } from '../../../models/enums/request-types.enum';
import { HttpService } from './../http.service';
import { HttpConfiguration } from '../../../app.http.config';
import { AdultMode } from '../../../models/enums/adultMode.enum';
import { ClientPaymentProfile } from '../../../shared/components/checkout/models/clientPaymentProfile';


@Injectable()
export class ClientService extends HttpService {

    constructor(httpConfig: HttpConfiguration, http: HttpClient) {
        super('api/client/', RequestTypes.InternalApi, httpConfig, http);
    }

    public getClientActiveService(): Observable<any> {
        return this.get('getClientActiveService', null).pipe();
    }

    public updateHiddenMessagesClaims(data: any): Observable<any> {
        return this.post('updateHiddenMessagesClaims', data).pipe();
    }

    public postChangePassword(data: any): Observable<any> {
        return this.post('postChangePassword', data).pipe();
    }

    public getLegacyClientInfo(): Observable<any> {
        return this.post('getLegacyClientInfo', null).pipe();
    }

    public getClientInfo(id: any, manager: any): Observable<any>  {
        return this.get(`getClientInfo/${id}?managerId=${manager}`, null).pipe();
    }

    public getClientPaymentProfiles(): Observable<any> {
        return this.get('getClientPaymentProfiles', null).pipe();
    }

    public setClientPaymentProfileAsDefault(profileId: string): Observable<any> {
        return this.post(`setClientPaymentProfileAsDefault/${profileId}`, null).pipe();
    }

    public deleteClientPaymentProfile(profileId: string): Observable<any> {
        return this.post(`deleteClientPaymentProfile/${profileId}`, null).pipe();
    }

    public addClientPaymentProfile(client: ClientPaymentProfile): Observable<any> {
        return this.post('addClientPaymentProfile', client).pipe();
    }

    public getStatement(): Observable<any> {
        return this.get('statement', null).pipe();
    }

    public payUnpaidSubscription(): Observable<any> {
        return this.post('payUnpaidSubscription', null).pipe();
    }

    public async getClientStatus(): Promise<any> {
        return await this.get('getClientStatus', null).pipe().toPromise();
    }

    public async getClientCurrentBalanceAsync(): Promise<any> {
        return await this.get('getClientBalance', null).pipe().toPromise();
    }

    public getClientCurrentBalance(): Observable<any> {
        return this.get('getClientBalance', null).pipe();
    }

    public getAffiliateBalance(): Observable<any> {
        return this.get('getAffiliateBalance', null).pipe();
    }

    public getDealerBalance(): Observable<any> {
        return this.get('getDealerBalance', null).pipe();
    }

    public getAvailableRewardPayout(): Observable<any> {
        return this.get('getAvailableRewardPayout', null).pipe();
    }

    public async setAdultMode(mode: AdultMode): Promise<any> {
        return await this.post('setAdultMode', mode).pipe().toPromise();
    }

    public async getAdultMode(): Promise<any> {
        return await this.get('getAdultMode', null).pipe().toPromise();
    }

    public async getDealerAccessCards(): Promise<any> {
        return await this.get('getDealerAccessCards', null).pipe().toPromise();
    }

    public async getDealerSubscriptionsAvailable(): Promise<any> {
        return await this.get('getDealerSubscriptionsAvailable', null).pipe().toPromise();
    }

    public getDealerClientInfo(clientId: string): Observable<any> {
        return this.get(`getDealerClientInfo/${clientId}`, null).pipe();
    }

    public getReferralDealerClientInfo(clientId: string): Observable<any> {
        return this.get(`getReferralDealerClientInfo/${clientId}`, null).pipe();
    }

    public getIsDealer(): Observable<any> {
        return this.get('getIsDealer', null).pipe();
    }

    public getIsReferralDealer(): Observable<any> {
        return this.get('getIsReferralDealer', null).pipe();
    }

    public getReferral(referralCode: string): Observable<any> {
        return this.get(`getReferral/${referralCode}`, null).pipe();
    }

    public addPromoPackage(promoId: string): Observable<any> {
        return this.post(`addPromoPackage/${promoId}`, null).pipe();
    }

    public getClientGift(id: any): Observable<any> {
        return this.get(`getClientGift/${id}`, null).pipe();
    }

    public unsubscribe(model: any): Observable<any> {
        return this.post(`unsubscribe`, model).pipe();
    }

    public isUnsubscribed(model: any): Observable<any> {
        return this.post(`isUnsubscribed`, model).pipe();
    }

    public currentClient(): Observable<any> {
        return this.get('currentClient', null).pipe();
    }

    public getCallTimes(): Observable<any> {
        return this.get(`getCallTimes`, null).pipe();
    }

    public requestAuthCode(clientId: any, phone: any, verificationType: any): Observable<any> {
        return this.post(`requestAuthCode?clientId=${clientId}&phone=${phone}&verificationType=${verificationType}`, null)
            .pipe();
    }

    public verifyClientPhone(model: any): Observable<any> {
        return this.post(`verifyClientPhone`, model).pipe();
    }

    public setUserDisplayLegacyNotification(status: any): Observable<any> {
        return this.post(`setUserDisplayLegacyNotification/${status}`, null).pipe();
    }

    public affiliateHistory(): Observable<any> {
        return this.get(`affiliateHistory`, null).pipe();
    }

    public sendAffiliateInviteEmail(email: string): Observable<any> {
        return this.post(`sendAffiliateInviteEmail`, {
            email: email
        }).pipe();
    }

    public getCurrentOrLastSubscription(): Observable<any> {
        return this.get('getCurrentOrLastSubscription', null).pipe();
    }

    public isPhoneVerified(id: number): Observable<any> {
        return this.get(`isPhoneVerified/${id}`, null).pipe();
    }
}



// WEBPACK FOOTER //
// ./src/app/core/http/internal/client.http.service.ts